import languageHelper from '../scripts/language-helper';

const $footer = $('.footer');
const $languageSelectBtn = $footer.find($('.language-toggle-btn'));
const $copyrightLinks = $footer.find($('.copyright-link'));
const $footerSubShelf = $footer.find($('.footer-sub-shelf'));
const $footerLanguageShelf = $footer.find($('.footer-language-shelf'));
const $languageSelectionLink = $footerLanguageShelf.find('.language-selection-item');
const $closeIconLegal = $footerSubShelf.find('.close-icon');
const $closeIconLanguage = $footerLanguageShelf.find('.close-icon');
const $legalText = $footerSubShelf.find('.legal-text');
const openShelfClassLegal = 'footer-sub-shelf-opened';
const openShelfClassLanguage = 'footer-language-shelf-opened';

//A user clicks on one of the copyright links in the footer
$copyrightLinks.click(function () {
    const legalText = $(this).data('legal');

    if (legalText.length) {
        $legalText.html(legalText);
        $footerSubShelf.addClass(openShelfClassLegal);
    }
});

$closeIconLegal.click(() => {
    $footerSubShelf.removeClass(openShelfClassLegal);
});

function handleClickAndEnter($element, action) {
    $element.on('keypress click', (e) => {
        if (e.which === 13 || e.type === 'click') { // 13 is enter key
            action(e);
        }
    });
}


handleClickAndEnter($languageSelectBtn, () => {
    //TODO: Assuming we will need to grab a cookie or something to determine
    // a user's preferred language, or this will be set upstream.
    $footerLanguageShelf.addClass(openShelfClassLanguage);
});

handleClickAndEnter($closeIconLanguage, () => {
    $footerLanguageShelf.removeClass(openShelfClassLanguage);
});

handleClickAndEnter($languageSelectionLink, (e) => {
    // ESPNWEB-1337: When you utilize Chrome's "Translate" feature, it puts the translated
    // text inside child elements (namely "font").  Since "font" now the target's node name,
    // the data-lang does not exist (it is on the parent/grandparent div), so we should always
    // use currentTarget in this case.  Note:  target = the element that the user clicked
    // on to activate the event.  currentTarget = the element that has the event listener.

    languageHelper.setupLink($(e.currentTarget));
});

//Check the browser's language setting and redirect if necessary
languageHelper.checkBrowserLanguage();

//Give proper link 'selected' state on page-load
languageHelper.setSelectedLanguageClass();
